import React, {createElement} from 'react';
import {Redirect, Route} from 'react-router-dom';
import {connect} from 'react-redux';
import types from 'prop-types';

import toastr from 'toastr';

export const AuthorizedRoute = ({
  component,
  render,
  userRole,
  roles = [],
  ...rest
}) => {
  const canRoute = roles.indexOf(userRole) !== -1;

  if (!canRoute) {
    toastr.info('You are not authorized to visit the requested page');
  }

  return (
    <Route
      {...rest}
      render={props =>
        canRoute ? (
          component ? (
            createElement(component, props)
          ) : (
            render(props)
          )
        ) : (
          <Redirect
            to={{
              pathname: '/',
              state: {from: props.location},
            }}
          />
        )
      }
    />
  );
};

AuthorizedRoute.propTypes = {
  userRole: types.string,
};

const mapStateToProps = state => {
  const {user = {}} = state.identity;
  return {
    userRole: user.role,
  };
};

export default connect(mapStateToProps)(AuthorizedRoute);
